import {
  GETKYBREPORTLIST_SUCCESS,
  GETKYBREPORTLIST_FAILED,
  RESET_GETKYBREPORTLIST,
  LOADING_GETKYBREPORTLIST,
  NETWORK_ERROR_GETKYBREPORTLIST,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetgetKybReportList = () => {
  return { type: RESET_GETKYBREPORTLIST };
};

const getKybReportListReq = (userData, authTokenIs) => async (dispatch) => {
  dispatch({ type: LOADING_GETKYBREPORTLIST });
  await partnerServices
    .post("getKybReportList", userData, { headers: { AuthToken: authTokenIs } })
    .then((res) => {
      switch (res.data.status) {
        case "success":
          dispatch(getKybReportListsuccess(res.data));
          break;
        default:
          dispatch(getKybReportListFailed(res.data));
          break;
      }
    })
    .catch((err) => {
      dispatch({
        type: NETWORK_ERROR_GETKYBREPORTLIST,
        payload: err,
      });
    });
};
function getKybReportListsuccess(data) {
  return {
    type: GETKYBREPORTLIST_SUCCESS,
    payload: data,
  };
}
function getKybReportListFailed(data) {
  return {
    type: GETKYBREPORTLIST_FAILED,
    payload: data,
  };
}

export { resetgetKybReportList, getKybReportListReq };
